<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
    <el-col :xs="24" :sm="24" :md="12" class="ml-20 mr-20">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="mr-20">個人資訊</span>
          <el-button type="primary" @click="connectLine">Line授權連動</el-button>
          <el-button v-if="userInfo.empno=='admin'" type="primary" @click="lineDialog = true">發linebot訊息</el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="userForm" label-width="80px">
          <el-row>
            <el-col :span="24" >
              <div style="text-align: center;" v-if="loading">
                <i class="el-icon-loading" style="font-size:22px"></i>上傳中...
              </div>
              <el-upload
                  drag
                  :multiple="false"
                  class="avatar-uploader"
                  action="/api/file/upload"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleAvatarSuccess"
                  :on-progress="avatarProgress"
                  :on-change="avatarChanged"
                  >
                <img v-if="form.avatar" :src="displayAvatar(form.avatar)" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">限上傳 jpg、png 格式，且大小不超過 3M</div>
              </el-upload>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="工號" prop="empno">
                <el-input :disabled="true" v-model="form.empno" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="姓名" prop="username" :label-width="formLabelWidth">
                <el-input v-model="form.username" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="聯絡電話" prop="phone" :label-width="formLabelWidth">
                <el-input v-model="form.phone" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :xs="24" :sm="24" :md="24" style="text-align: right">
              <el-button type="primary" @click="saveData('userForm')">確 定</el-button>
            </el-col>
          </el-row>
        </el-form>

      </el-card>
    </el-col>

    <el-dialog title="發送LINE訊息"
               :visible.sync="lineDialog"
               width="50%"
               @close="lineDialog=false">
               
      <el-form :model="lineForm"
               ref="lineForm"
               label-width="180px">
        <el-form-item label="訊息" prop="message">
          <el-input v-model="lineForm.message" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="我的LINE" prop="token">
          <el-input v-model="lineForm.token" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="lineDialog = false">取 消</el-button>
        <!-- <el-button type="primary" @click="sendNotify('lineForm')">發送</el-button> -->
        <el-button type="primary" @click="sendBot('lineForm')" >發送訊息到我的LINE</el-button>
      </div>
    </el-dialog>

  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapGetters} from 'vuex'
import store from "@/store";

export default {
  name: "UseProfile",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      clientId: process.env.VUE_APP_LINE_CLIENT_ID,
      callBack: process.env.VUE_APP_LINE_CALLBACK,
      notifyUrl: process.env.VUE_APP_LINE_NOTIFY,
      formLabelWidth: '',
      loading: false,
      form: {
        id: '',
        empno: '',
        username: '',
        phone: '',
        avatar: '',
        token:''
      },
      rules: {
        username: [{validator: checkName, trigger: 'change'}],
        phone: [{validator: checkName, trigger: 'change'}]
      },
      devMode: process.env.VUE_APP_DEV_MODE,
      lineDialog:false,
      lineForm:{
        message:'',
        token:'U303e8ba3b90d3c820a601d8cdba8c742'
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token'])
  },
  methods: {

    loadData() {
      this.form.id = this.userInfo.id
      this.form.avatar = this.userInfo.avatar
      this.form.empno = this.userInfo.empno
      this.form.username = this.userInfo.username
      this.form.phone = this.userInfo.phone
      this.form.token = this.userInfo.token
    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            await this.$store.dispatch('user/saveUser', this.form)
            await this.$store.dispatch('login/getUserInfo', this.form.token)
            this.showResult('success', '資料更新成功.')
            this.loadData()
          } catch (e) {
            this.showResult('error', '資料更新失敗' + e)
          }
        }
      })
    },
    handleAvatarSuccess(res, file) {
      console.log("handleAvatarSuccess..")
      // this.loading = false
      this.form.avatar = res.uuid
    },

    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      const isLtM = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('限上傳 jpg、png 格式');
      }
      if (!isLtM) {
        this.$message.error('圖片大小超過 5M');
      }
      return isJPG && isLtM;
    },

    avatarProgress(){
      this.loading = true
      console.log("avatarProgress.....")
    },
    avatarChanged(){
      this.loading = false
      console.log("avatarChanged.....")
    },

    connectLine(){
      //console.log(`${this.notifyUrl}&client_id=${this.clientId}&redirect_uri=${this.callBack}&state=${this.userInfo.id}`)
      window.open(`${this.notifyUrl}&client_id=${this.clientId}&redirect_uri=${this.callBack}&state=${this.userInfo.id}`,"_new")
    },

    sendBot(){
      let query = {
        msg: this.lineForm.message,
        userId: this.lineForm.token
      }
      this.request.get("/line/bot", {params: query} ).then(res => {
        if (res.code === '200') {
          console.log(res.data)
        }
      })
    },
  },
  mounted() {
    console.log("this.loadData:", this.token)
    this.loadData()
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


</style>
